(() => {
  const selectors = '.Avada-Fbt__ProductContent-subTitle,.Avada-Fbt__ProductContent-discountText,[class*="_lably_item"]';
  const clean = () => {
    document.querySelectorAll(selectors).forEach(element => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const current = node.nodeValue;
        const corrected = current.replace(/(\d+%)\1+/g, '$1').replace(/(discount|bundle)(\d+%)+\s*$/i, '$1').replace(/\bAvaliable\b/g, 'Available');
        if (corrected !== current) node.nodeValue = corrected;
      }
    });
  };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; clean(); });
  });
  clean();
  observer.observe(document.body, {childList: true, subtree: true, characterData: true});
})();
